import {Observable} from 'rxjs';
import {IOrdenesRefMaq} from './../modelos/IOrdenesRefMaq';
import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root'
})
export class OrdenesReferenciaMaquinaService {
  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<IOrdenesRefMaq[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesRefMaq.obtenerTodo
    );
  }

  obtenerPorId(idGarita: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.ordenesRefMaq.obtenerPorId +
      idGarita
    );
  }

  crear(request: IOrdenesRefMaq) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ordenesRefMaq.crear,
      request
    );
  }

  editar(request: IOrdenesRefMaq) {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.ordenesRefMaq.actualizar,
      request
    );
  }

  borrar(params: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url +
      this.diccionarioModulo.url.ordenesRefMaq.eliminar +
      params
    );
  }
}
